import { createApiError } from '@/components/primitives/ApiError'

export const NAME = 'popup'

const ACTIVATE_POPUP = `${NAME}/ACTIVATE_POPUP`
const CLOSE_POPUP = `${NAME}/CLOSE_POPUP`
// @ts-ignore
export const setApiErrorPopup = textId => activatePopup(createApiError(textId))
// @ts-ignore
export function activatePopup(content) {
  return {
    type: ACTIVATE_POPUP,
    content: content,
  }
}

export function closePopup() {
  return {
    type: CLOSE_POPUP,
  }
}

const initialState = {
  active: false,
  content: undefined,
}
// @ts-ignore
function popup(state = initialState, action) {
  switch (action.type) {
    case ACTIVATE_POPUP:
      return {
        ...state,
        active: true,
        content: action.content,
      }
    case CLOSE_POPUP:
      return {
        ...state,
        active: false,
      }
    default:
      return state
  }
}
// @ts-ignore
const getState = state => state[NAME]
// @ts-ignore
export const getPopupContent = state => getState(state).content
// @ts-ignore
export const isPopupActive = state => getState(state).active

export default popup
